export type CourierDeliveryType = "parcel_locker" | "courier";
export type CourierStatus = "pending" | "ordered" | "rejected" | "cancelled";

export interface CourierRequest {
  id: string;
  number: number;
  submitted_at: string;
  requested_at: string | null;
  delivery_type: CourierDeliveryType;
  delivery_type_display: string;
  pickup_address: string;
  size: string;
  recipient_address: string;
  notes: string;
  requested_by: string | null;
  requested_by_name: string | null;
  status: CourierStatus;
  status_display: string;
  ordered_by: string | null;
  ordered_by_name: string | null;
  ordered_at: string | null;
  ordered_for: string | null;
  label_file: string | null;
  label_file_url: string | null;
  is_received: boolean;
  received_at: string | null;
  created_at: string;
  updated_at: string;
}

export const COURIER_STATUS_COLORS: Record<CourierStatus, "yellow" | "blue" | "red" | "gray"> = {
  pending: "yellow",
  ordered: "blue",
  rejected: "red",
  cancelled: "gray",
};

export const PICKUP_CITY_SUGGESTIONS = ["Biuro Wrocław", "Biuro Opole"];
